import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.999 13.063a1.031 1.031 0 1 0 0-2.063 1.031 1.031 0 0 0 0 2.063"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.874 6.875H14.78V4.469a3.781 3.781 0 0 0-7.562 0v2.406H4.124A1.377 1.377 0 0 0 2.749 8.25v9.625a1.377 1.377 0 0 0 1.375 1.375h13.75a1.376 1.376 0 0 0 1.375-1.375V8.25a1.376 1.376 0 0 0-1.375-1.375m-6.187 7.462v1.476a.687.687 0 1 1-1.375 0v-1.476a2.406 2.406 0 1 1 1.375 0m1.718-7.462H8.593V4.469a2.406 2.406 0 0 1 4.812 0z"
    }, null, -1)
  ])))
}
export default { render: render }